import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ConversationListResponse =
  components["schemas"]["ConversationListResponse"];

export interface ListConversationsParams {
  search?: string;
  limit?: number;
  cursor?: string;
}

/** GET /v1/chat/conversations — typed end to end by the generated contract. */
export async function getConversations(
  params: ListConversationsParams = {},
): Promise<ConversationListResponse> {
  return unwrap(
    await api.GET("/v1/chat/conversations", { params: { query: params } }),
  );
}
